<template>
    <div class="wrapper">
        <div class="svg-wrap" :style="`width: ${width}; height: ${height}`">
            <!-- Circle Start -->
            <svg id="circle-start" viewBox="0 0 310 310">
                <circle cx="155" cy="155" :r="stroke > 11 ? 145 : 150" :style="`stroke-width: ${stroke}`" />
            </svg>

            <!-- Check SVG -->
            <svg id="check" viewBox="0 0 310 310" v-if="isCorrect">
                <path d="M74,165l57.5,57.5C245.5,108.5,281,73,281,73" :style="`stroke-width: ${strokeMark}`" />
            </svg>

            <!-- Cross SVG -->
            <svg id="cross" viewBox="0 0 131 131" v-else>
                <path d="M18.1985 24L112 107.108" :style="`stroke-width: ${parseFloat(strokeMark) / 2.1}`" />
                <path d="M112 24.1528L18.1985 106.955" :style="`stroke-width: ${parseFloat(strokeMark) / 2.1}`" />
            </svg>

            <!-- Circle End -->
            <svg id="circle-end" viewBox="0 0 310 310">
                <circle cx="155" cy="155" :r="stroke > 11 ? 145 : 150" :style="`stroke-width: ${stroke}`" />
            </svg>
        </div>

        <ExplosionAnimation
            v-if="isCorrect && alreadyShow"
            :size="300"
            :spriteCount="40"
            :spriteSizesMin="5"
            :spriteSizesMax="10"
            :color="color"
        />
    </div>
</template>

<script>
import ExplosionAnimation from '@/components/ExplosionAnimation.vue'

export default {
    props: {
        isCorrect: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '100px'
        },
        height: {
            type: String,
            default: '100px'
        },
        stroke: {
            type: String,
            default: '8'
        },
        strokeMark: {
            type: String,
            default: '8'
        }
    },

    components: {
        ExplosionAnimation
    },

    data() {
        return {
            alreadyShow: false,
            color: null
        }
    },

    mounted() {
        if (this.isCorrect) {
            setTimeout(() => {
                this.alreadyShow = true
            }, 750)
        } else {
            setTimeout(() => {
                this.$emit('alreadyShowWrongAnimate')
            }, 1400)
        }

        this.color = getComputedStyle(document.documentElement).getPropertyValue('--ui-color') || '#fff'

        this.$nextTick(() => {
            this.$emit('alreadyShow')
        })
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    position: relative;
}

.svg-wrap {
    position: relative;
    margin: 0 auto;
    filter: drop-shadow(2px 2px 6px var(--question-shadow-color));

    #circle-start {
        fill: none;
        position: absolute;
        top: 0;
        left: 0;
        height: inherit;
        opacity: 1;
        transform: rotate(-33deg);
        animation: circle-start ease-in 1.5s;
        animation-direction: alternate;
        stroke-linecap: round;
        stroke-dasharray: 291, 943;
        stroke-dashoffset: -943;
        animation-fill-mode: both;

        circle {
            fill: none;
            // stroke-width: 8;
            // stroke-miterlimit: 10;
            stroke: var(--ui-color);
        }
    }

    #check {
        fill: none;
        position: absolute;
        top: 0;
        left: 0;
        height: inherit;
        opacity: 0;
        stroke-dasharray: 290, 9000;
        stroke-dashoffset: -290;
        animation: check ease-out 1.5s;
        animation-direction: alternate;
        stroke-linecap: round;
        animation-fill-mode: both;

        path {
            fill: none;
            stroke: var(--ui-color);
            // stroke-width: 8;
            // stroke-miterlimit: 10;
        }
    }

    #cross {
        fill: none;
        position: absolute;
        top: 0;
        left: 0;
        height: inherit;
        opacity: 0;
        stroke-linecap: round;
        stroke-dasharray: 86, 9000;
        stroke-dashoffset: 90;
        animation: cross ease-out 1.5s;
        animation-direction: alternate;
        animation-fill-mode: both;

        path {
            fill: none;
            stroke: var(--ui-color);
            // stroke-width: 4;
            // stroke-miterlimit: 10;
        }
    }

    #circle-end {
        fill: none;
        position: absolute;
        top: 0;
        left: 0;
        height: inherit;
        opacity: 1;
        stroke-dasharray: 943, 9000;
        stroke-dashoffset: 0;
        animation: circle-end ease-in-out 1.5s;
        animation-direction: alternate;
        stroke-linecap: round;
        transform: scale(1);
        animation-fill-mode: both;

        circle {
            fill: none;
            stroke: var(--ui-color);
            // stroke-width: 8;
            // stroke-miterlimit: 10;
        }
    }

    @keyframes circle-start {
        0% {
            opacity: 0;
            stroke-dasharray: 40, 943;
            stroke-dashoffset: 0;
            transform: rotate(-73deg);
        }
        40% {
            opacity: 0.5;
        }
        50% {
            stroke-dasharray: 200, 943;
            transform: rotate(-33deg);
        }
        51% {
            opacity: 1;
        }
        58% {
            stroke-dasharray: 0, 943;
            stroke-dashoffset: -943;
            opacity: 1;
        }
        59% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes check {
        0% {
            stroke-dasharray: 290, 9000;
            stroke-dashoffset: -294;
            opacity: 0;
        }
        51% {
            stroke-dasharray: 290, 9000;
            stroke-dashoffset: -294;
            opacity: 0;
        }
        51% {
            opacity: 1;
        }
        63% {
            opacity: 1;
        }
        63% {
            stroke-dasharray: 291, 9000;
            stroke-dashoffset: 55;
            opacity: 1;
        }
        100% {
            stroke-dasharray: 291, 9000;
            stroke-dashoffset: 43;
            opacity: 1;
        }
    }

    @keyframes cross {
        0% {
            stroke-dasharray: 86, 9000;
            stroke-dashoffset: 90;
            opacity: 0;
        }
        51% {
            stroke-dasharray: 86, 9000;
            stroke-dashoffset: 90;
            opacity: 0;
        }
        51% {
            opacity: 1;
        }
        63% {
            opacity: 1;
        }
        63% {
            stroke-dasharray: 86, 9000;
            stroke-dashoffset: -27;
            opacity: 1;
        }
        100% {
            stroke-dasharray: 86, 9000;
            stroke-dashoffset: -21;
            opacity: 1;
        }
    }

    @keyframes circle-end {
        0% {
            opacity: 0;
            transform: scale(1);
        }
        60% {
            opacity: 0;
        }
        80% {
            opacity: 1;
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
}
</style>
